import { Button, StyledCheckbox } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from '../DataTable';

interface Props {
    filters: Filter[];
    enabledFilters: string[];
    callback?: (nv: string[]) => void;
    hideSaveButton?: boolean;
}

export const FilterSelection = ({ filters, enabledFilters, callback, hideSaveButton }: Props) => {
    const { t } = useTranslation('datatable');
    const [enabledFilterState, setEnabledFilterState] = useState(enabledFilters);
    const handleChange = (key: string) => {
        if (enabledFilterState.includes(key)) {
            setEnabledFilterState(enabledFilterState.filter((k) => k !== key));
        } else {
            setEnabledFilterState([...enabledFilterState, key]);
        }
    };

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <div className="tw-space-y-1">
                {filters?.map(
                    (col) =>
                        col.filterType && (
                            <StyledCheckbox
                                key={col.filterKey}
                                onChange={() => handleChange(col.filterKey)}
                                name={col.filterKey}
                                value={col.filterKey}
                                checked={enabledFilterState.includes(col.filterKey)}
                            >
                                {col.filterName}
                            </StyledCheckbox>
                        )
                )}
            </div>
            {!hideSaveButton && (
                <Button className="tw-py-5" onPress={() => callback(enabledFilterState)}>
                    {t('filters.saveAndClose')}
                </Button>
            )}
        </div>
    );
};

export default FilterSelection;
